<!-- Blocking overlay — ปิดไม่ได้จนกว่าจะเปลี่ยน password สำเร็จ -->
<div class="fixed inset-0 bg-black/70 backdrop-blur-md z-9999 flex items-center justify-center p-4"
     data-testid="force-change-password-modal">
  <div class="bg-surface-raised rounded-2xl w-full max-w-md flex flex-col border border-border-subtle"
       style="box-shadow: var(--shadow-xl)">

    <!-- Header -->
    <div class="px-6 pt-6 pb-4 border-b border-border-subtle flex items-start gap-3">
      <div class="w-10 h-10 rounded-full flex items-center justify-center shrink-0"
           style="background: var(--color-warning-bg, #fef3c7); color: var(--color-warning-text, #92400e);">
        <span class="material-symbols-outlined">lock_reset</span>
      </div>
      <div>
        <h2 class="font-bold text-text-primary text-lg">ตั้งรหัสผ่านใหม่</h2>
        <p class="text-xs text-text-secondary mt-0.5">
          เพื่อความปลอดภัย กรุณาตั้งรหัสผ่านใหม่ก่อนเริ่มใช้งานระบบ
        </p>
      </div>
    </div>

    <!-- Body -->
    <form (submit)="$event.preventDefault(); submit()" class="px-6 py-4 space-y-4">
      <div>
        <label class="label">รหัสผ่านใหม่ <span class="text-red-500">*</span></label>
        <div class="relative">
          <input data-testid="fcp-password" autocomplete="new-password"
                 [type]="showPassword() ? 'text' : 'password'"
                 [value]="password()" (input)="password.set($any($event.target).value)"
                 class="input-field w-full pr-10" [class.input-invalid]="passwordError()"
                 placeholder="กรอกรหัสผ่านใหม่ (อย่างน้อย 6 ตัวอักษร)" maxlength="100">
          <button type="button" (click)="showPassword.set(!showPassword())" data-testid="fcp-toggle-password"
                  class="absolute right-3 top-1/2 -translate-y-1/2 flex items-center justify-center text-text-secondary hover:text-text-secondary cursor-pointer"
                  [attr.aria-label]="showPassword() ? 'ซ่อนรหัสผ่าน' : 'แสดงรหัสผ่าน'">
            <span class="material-symbols-outlined text-[20px] leading-none">{{ showPassword() ? 'visibility_off' : 'visibility' }}</span>
          </button>
        </div>
        @if (passwordError()) { <p class="error-text">{{ passwordError() }}</p> }
      </div>

      <div>
        <label class="label">ยืนยันรหัสผ่านใหม่ <span class="text-red-500">*</span></label>
        <div class="relative">
          <input data-testid="fcp-confirm" autocomplete="new-password"
                 [type]="showConfirm() ? 'text' : 'password'"
                 [value]="confirmPassword()" (input)="confirmPassword.set($any($event.target).value)"
                 class="input-field w-full pr-10" [class.input-invalid]="confirmError()"
                 placeholder="พิมพ์รหัสผ่านอีกครั้ง" maxlength="100">
          <button type="button" (click)="showConfirm.set(!showConfirm())" data-testid="fcp-toggle-confirm"
                  class="absolute right-3 top-1/2 -translate-y-1/2 flex items-center justify-center text-text-secondary hover:text-text-secondary cursor-pointer"
                  [attr.aria-label]="showConfirm() ? 'ซ่อนรหัสผ่าน' : 'แสดงรหัสผ่าน'">
            <span class="material-symbols-outlined text-[20px] leading-none">{{ showConfirm() ? 'visibility_off' : 'visibility' }}</span>
          </button>
        </div>
        @if (confirmError()) { <p class="error-text">{{ confirmError() }}</p> }
      </div>

      @if (serverError()) {
        <div class="rounded-lg bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 px-3 py-2">
          <p class="text-sm text-red-700 dark:text-red-400">{{ serverError() }}</p>
        </div>
      }

      <button type="submit" data-testid="fcp-submit" [disabled]="isSubmitting()"
              class="w-full px-5 py-2.5 rounded-full text-sm font-semibold text-white transition-all cursor-pointer disabled:opacity-60 disabled:cursor-not-allowed"
              style="background: linear-gradient(135deg, var(--color-accent), var(--color-accent-dark)); box-shadow: 0 2px 8px rgba(34,197,94,0.3)">
        {{ isSubmitting() ? 'กำลังบันทึก...' : 'บันทึกรหัสผ่านใหม่' }}
      </button>
    </form>
  </div>
</div>
